module.exports = __webpack_public_path__ + "assets/e7cef17e35b9004cc310c13cc13e5163.mp3";